// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'purchases-credit-memo-payment.page.title': 'Credit Memo Payments',
    'purchases-credit-memo-payment.page.search_results': 'Search Results',
    'purchases-credit-memo-payment.page.create.title': 'Issue Payment Refund',
    'purchases-credit-memo-payment.page.view.title': 'Issued Refund Details',
    'purchases-credit-memo-payment.page.all': 'All',

    'purchases-credit-memo-payment.button.cancel': 'Cancel',
    'purchases-credit-memo-payment.button.select': 'Select',
    'purchases-credit-memo-payment.button.find': 'Find Payments',
    'purchases-credit-memo-payment.button.search': 'Apply',
    'purchases-credit-memo-payment.button.create': 'Issue Refund',
    'purchases-credit-memo-payment.button.new': 'New Payment',
    'purchases-credit-memo-payment.button.save': 'Save Changes',
    'purchases-credit-memo-payment.button.delete': 'Permanently Delete',
    'purchases-credit-memo-payment.button.view': 'View Refund',
    'purchases-credit-memo-payment.button.restore': 'Restore',
    'purchases-credit-memo-payment.button.reset': 'Reset',

    'purchases-credit-memo-payment.placeholder.search': 'Search credit memo payments',

    'purchases-credit-memo-payment.link.create_first_credit_memo_payment': 'Click here to create your first credit memo payment',
    'purchases-credit-memo-payment.link.credit_memo_payments': ' Return to Credit Memo Payments',
    'purchases-credit-memo-payment.link.retry': 'Click here to retry',

    'purchases-credit-memo-payment.checkbox.all': 'Check All',
    'purchases-credit-memo-payment.checkbox.actions_label': 'with selected',

    'purchases-credit-memo-payment.label.credit_memo_name': 'Credit Memo',
    'purchases-credit-memo-payment.label.transaction_date': 'Transaction Date',
    'purchases-credit-memo-payment.label.bank_account': 'Bank Account',
    'purchases-credit-memo-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'purchases-credit-memo-payment.label.is_reconciled': 'Is Reconciled',
    'purchases-credit-memo-payment.label.payment_method': 'Payment Method',
    'purchases-credit-memo-payment.label.reference_code': 'Reference Code',
    'purchases-credit-memo-payment.label.memo': 'Memo',
    'purchases-credit-memo-payment.label.currency_name': 'Currency',
    'purchases-credit-memo-payment.label.currency_amount_in_cents': 'Amount',
    'purchases-credit-memo-payment.label.cancelled_on': 'Cancelled On',
    'purchases-credit-memo-payment.label.cancellation_reason': 'Cancellation Reason',
    'purchases-credit-memo-payment.label.credit_memo_payment_status': 'Credit Memo Payment Status',

    'purchases-credit-memo-payment.sort.field_label': 'Field',
    'purchases-credit-memo-payment.sort.direction_label': 'Direction',
    'purchases-credit-memo-payment.sort.direction_ascending': 'Ascending',
    'purchases-credit-memo-payment.sort.direction_descending': 'Descending',

    'purchases-credit-memo-payment.modal.title.credit_memo_payment_delete_permanently': 'Delete Credit Memo Payment',
    'purchases-credit-memo-payment.modal.title.credit_memo_payment_restore': 'Restore Credit Memo Payment',

    'purchases-credit-memo-payment.modal.message.credit_memo_payment_delete_permanently':
        'Are you sure that you want to permanently delete this credit memo payment? This action cannot be undone. | Are you sure that you want to permanently delete these credit memo payments? This action cannot be undone.',
    'purchases-credit-memo-payment.modal.message.credit_memo_payment_restore': 'Are you sure that you want to restore this credit memo payment? | Are you sure that you want to restore these credit memo payments?',

    'purchases-credit-memo-payment.success.message.credit_memo_payment_created': 'Your credit memo payment has been created',
    'purchases-credit-memo-payment.success.message.credit_memo_payment_updated': 'Your credit memo payment has been updated',
    'purchases-credit-memo-payment.success.message.credit_memo_payment_restored': 'Your credit memo payment has been restored | All selected credit memo payments were restored',
    'purchases-credit-memo-payment.success.message.credit_memo_payment_deleted': 'Your credit memo payment has been permanently deleted | All selected credit memo payments were permanently deleted',

    'purchases-credit-memo-payment.error.message.credit_memo_payment_deleted': 'This credit memo payment was already permanently deleted | These credit memo payments were already permanently deleted',
    'purchases-credit-memo-payment.error.message.credit_memo_payment_restored': 'This credit memo payment was already restored | These credit memo payments were already restored',
    'purchases-credit-memo-payment.error.message.error_loading_page': 'Sorry, there was an error loading credit memo payment.| Sorry, there was an error loading credit memo payments.',
};
